import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ConfirmModalHeader.module.css';

export type ConfirmModalHeaderProps = ComponentProps<'div'>;

export const ConfirmModalHeader: FunctionComponent<ConfirmModalHeaderProps> =
  React.memo((props) => {
    const { children, className, ...remainingProps } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.header)}
      >
        {children}
      </div>
    );
  });
